// Available icons for generic table actions.
export const TABLE_MATERIAL_ICONS = {
  details: { icon: 'visibility' },
  cancel: { icon: 'cancel' },
  edit: { icon: 'edit_note' },
  reopen: { icon: 'refresh' },
  delete: { icon: 'delete' },
  update: { icon: 'sync' },
  undo: { icon: 'undo' },
  copy: { icon: 'content_copy' },
  manageNotifications: { icon: 'mark_as_unread' },
  transform: { icon: 'transform' },
  send: { icon: 'send' },
  approve: { icon: 'check_circle_outline' },
  block: { icon: 'block' },
  mail: { icon: 'mail' },
  article: { icon: 'article' },
  analyze: { icon: 'content_paste_search' },
  registerBid: { icon: 'gavel' },
  registerContractOffer: { icon: 'local_shipping' },
  share: { icon: 'share' },
  convertToSpot: { icon: 'sell' },
  convertToCollection: { icon: 'local_shipping' },
} as const;
